export const SET_INTENT = 'SET_INTENT';
export const SET_FLOW = 'SET_FLOW';
export const SET_PHONE = 'SET_PHONE';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_DAY = 'SET_DAY';
export const SET_TIMESLOT = 'SET_TIMESLOT';

export const setIntent = intent => ({
  type: SET_INTENT,
  value: {intent},
});

export const setFlow = flow => ({
  type: SET_FLOW,
  value: {flow},
});

export const setPhone = phone => ({
  type: SET_PHONE,
  value: {phone},
});

export const setEmail = email => ({
  type: SET_EMAIL,
  value: {email},
});

export const setDay = day => ({
  type: SET_DAY,
  value: {day},
});

export const setTimeslot = timeslot => ({
  type: SET_TIMESLOT,
  value: {timeslot},
});
